// countryCodes.js
export const country = [
  { name: "Pakistan", flag: "🇵🇰" },          // PKR
  { name: "Palestine", flag: "🇵🇸" },        // ILS
  { name: "Bangladesh", flag: "🇧🇩" },       // BDT
  { name: "India", flag: "🇮🇳" },             // INR
  { name: "Afghanistan", flag: "🇦🇫" },       // AFN
  { name: "Yemen", flag: "🇾🇪" },            // YER
  { name: "Syria", flag: "🇸🇾" },            // SYP
  { name: "Iran", flag: "🇮🇷" },              // IRR
  { name: "Iraq", flag: "🇮🇶" },             // IQD
  { name: "Jordan", flag: "🇯🇴" },           // JOD
  { name: "Lebanon", flag: "🇱🇧" },          // LBP
  { name: "Egypt", flag: "🇪🇬" },             // EGP
  { name: "Sudan", flag: "🇸🇩" },            // SDG
  { name: "Turkey", flag: "🇹🇷" },            // TRY

];

export default country;